import { relatedContent } from '../helpers/search-helpers';
import { computeFaqClick } from '../helpers/faq-helper';

document.addEventListener('turbolinks:load', () => {
  const body = $('body');
  if (body.data('controller') !== 'frequently_asked_questions' || body.data('action') !== 'index') return;

  relatedContent('.search-faqs', '.question-container', 'faqs', '.search-faqs .category-container');
  computeFaqClick();
});
